// extracted by mini-css-extract-plugin
module.exports = {"genericErrorWrapper":"ErrorBoundary_genericErrorWrapper__L7bus","Container":"ErrorBoundary_Container__YWJpS"};